module.exports = __webpack_public_path__ + "static/img/home-img1.9130978.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home-img1.png
// module id = Bhy+
// module chunks = 1